"use client";

import { Instagram, Linkedin, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i} className="h-5 w-32 bg-muted/30 animate-pulse" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="group inline-flex items-center text-foreground/85 hover:text-primary transition-colors duration-200 text-[0.95rem] font-default">
            <span className="relative">
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
const investments = [{
  label: "Residential Acquisitions",
  href: "/HomePage"
}, {
  label: "Property Renovation",
  href: "/HomePage"
}, {
  label: "Long-term Rentals",
  href: "/HomePage"
}, {
  label: "Investor Relations",
  href: "/HomePage"
}, {
  label: "Community Impact",
  href: "/HomePage"
}];
const ticker = ["INTEGRITY", "LEGACY", "VALUE", "RESPONSIBILITY", "GROWTH"];
export default function Footer() {
  return <section data-section-id="1436" id="footer" className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -right-24 h-[420px] w-[420px] rounded-lg opacity-[0.08]">
        <div className="h-full w-full rounded-lg border border-secondary" style={{
        borderRadius: "2px"
      }} />
      </div>
      <div aria-hidden="true" className="pointer-events-none absolute -top-20 -right-12 h-56 w-56 opacity-[0.12]">
        <div className="h-full w-full border border-secondary" style={{
        borderRadius: "2px"
      }} />
      </div>

      <div className="mx-auto max-w-[1440px] px-5 md:px-8 lg:px-12 py-24 md:py-32">
        {}
        <div className="mb-16 md:mb-20">
          <span className="font-mono text-[0.78rem] tracking-[0.14em] uppercase text-foreground/60">
            § 01 · ARCHITECTS OF LEGACY
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          {}
          <div className="md:col-span-5 flex flex-col">
            <Link to="/" className="inline-flex items-center gap-4 mb-8">
              {}
              <span aria-hidden="true" className="inline-block h-9 w-9 border-2 border-secondary" style={{
              borderRadius: "2px"
            }} />
              <WvcLogo className="h-8 w-auto" />
            </Link>

            <p className="max-w-[280px] font-default text-[1rem] leading-[1.6] text-foreground/70">
              Summertime Lane Investments builds lasting value through responsible residential real estate acquisition and thoughtful community development.
            </p>

            {}
            <div className="mt-10 mb-6 flex items-center gap-1.5">
              <span className="block h-px w-20 bg-secondary" />
              <span className="block h-1.5 w-1.5 bg-secondary" style={{
              borderRadius: "2px"
            }} />
            </div>

            <span className="font-mono text-[0.75rem] tracking-[0.14em] uppercase text-foreground/55">
              EST. 2024
            </span>
            <span className="font-mono text-[0.75rem] tracking-[0.08em] text-foreground/45 mt-1.5">
              Residential Investment Firm
            </span>
          </div>

          {}
          <div className="md:col-span-3">
            <h3 className="font-mono text-[0.75rem] tracking-[0.14em] uppercase text-secondary mb-6">
              Our Focus
            </h3>
            <ul className="flex flex-col gap-3">
              {investments.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="group inline-flex items-center text-foreground/85 hover:text-primary transition-colors duration-200 text-[0.95rem] font-default">
                    <span className="relative">
                      {item.label}
                      <span className="absolute -bottom-1 left-0 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-2">
            <h3 className="font-mono text-[0.75rem] tracking-[0.14em] uppercase text-secondary mb-6">
              Company
            </h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-2">
            <h3 className="font-mono text-[0.75rem] tracking-[0.14em] uppercase text-secondary mb-6">
              Connect
            </h3>
            <ul className="flex flex-col gap-3">
              <li data-index={0}>
                <Link to="mailto:invest@summertimelane.com" className="group inline-flex items-start gap-2 text-foreground/85 hover:text-primary transition-colors duration-200 text-[0.9rem] font-default break-all">
                  <span className="mt-2 h-1 w-1 shrink-0 bg-secondary" style={{
                  borderRadius: "2px"
                }} />
                  <span className="relative">
                    Email Us
                    <span className="absolute -bottom-1 left-0 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
                  </span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="group inline-flex items-start gap-2 text-foreground/85 hover:text-primary transition-colors duration-200 text-[0.9rem] font-default">
                  <span className="mt-2 h-1 w-1 shrink-0 bg-secondary" style={{
                  borderRadius: "2px"
                }} />
                  <Linkedin className="h-3.5 w-3.5 mt-0.5" strokeWidth={1.25} />
                  <span className="relative">
                    LinkedIn
                    <span className="absolute -bottom-1 left-0 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
                  </span>
                </Link>
              </li>
              <li data-index={2}>
                <Link to="#" className="group inline-flex items-start gap-2 text-foreground/85 hover:text-primary transition-colors duration-200 text-[0.9rem] font-default">
                  <span className="mt-2 h-1 w-1 shrink-0 bg-secondary" style={{
                  borderRadius: "2px"
                }} />
                  <Instagram className="h-3.5 w-3.5 mt-0.5" strokeWidth={1.25} />
                  <span className="relative">
                    Instagram
                    <span className="absolute -bottom-1 left-0 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-24 mb-8 flex items-center gap-1.5">
          <span className="block h-px flex-1 bg-secondary/40" />
          <span className="block h-1.5 w-1.5 bg-secondary" style={{
          borderRadius: "2px"
        }} />
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center">
          <div className="md:col-span-6">
            <span className="font-mono text-[0.72rem] tracking-[0.14em] uppercase text-foreground/55">
              © 2025 Summertime Lane Investments. All rights reserved.
            </span>
          </div>

          <div className="md:col-span-3">
            <ul className="flex flex-wrap gap-x-4 gap-y-2">
              {[{
              label: "Privacy",
              to: "#"
            }, {
              label: "Terms",
              to: "#"
            }, {
              label: "Legal",
              to: "#"
            }].map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.to} className="group font-mono text-[0.72rem] tracking-[0.14em] uppercase text-foreground/55 hover:text-primary transition-colors duration-200">
                    <span className="relative">
                      {item.label}
                      <span className="absolute -bottom-1 left-0 h-px w-0 bg-secondary transition-all duration-[240ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-3 overflow-hidden">
            <div className="flex items-center gap-3 whitespace-nowrap overflow-hidden">
              {ticker.map((item, i) => <span key={i} data-index={i} className="font-mono text-[0.7rem] tracking-[0.08em] uppercase text-foreground/45 inline-flex items-center gap-3">
                  {item}
                  {i < ticker.length - 1 && <span className="h-1 w-1 bg-secondary/60" style={{
                borderRadius: "2px"
              }} />}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}